import React, { Component } from 'react';
import MyBillsApi from '../api/MyBillsApi';
import './css/ElectricityPage.css';
import bulb from '../images/DTh/bulb-svgrepo-com.svg';
import coverImage from "../images/Putatoe-Illustrations/8.png"
import notify from '../error';
import { useNavigate } from 'react-router-dom';
import { useGlobalContext } from '../context';

export default function ElectrityPage(props) {
   const { loginDetail, Userprofile } = useGlobalContext();
  const [operatorList, setOperatorList] = React.useState();
  
  const ElectricityPageList = async () => {
    const response = await MyBillsApi.OtherOperatorList('Electricity');
    console.log(response);
    setOperatorList(response.data.operator_list);
  };
  React.useEffect(() => {
    ElectricityPageList();
  }, []);
  const [fieldValid, setFieldValid] = React.useState(false); // to check input is valid or not
  const [formData, setFormData] = React.useState({
    operator_code: '',
    DTH: '',
    amount: '',
    coupon_id: null,
    payment_method: '',
    operatorIndex: -1, 
  });

  function ChangeValue(e) {
    const { name, value, type, checked } = e.target;
  
    setFormData((prevFormData) => {
      let indexValue = -1;
  
      if (name === 'operator_code') {
        // Assuming operatorList is an array of objects with an op_code property
        indexValue = operatorList.findIndex(item => item.op_code === value);
        return {
          ...prevFormData,
          [name]: type === 'checkbox' ? checked : value,
          operatorIndex: indexValue,  // Setting the index for operator
        };
      } 
  
      return {
        ...prevFormData,
        [name]: type === 'checkbox' ? checked : value,
      };
    });
  
    // Log the updated formData
    console.log(formData);
    if (
      formData.DTH &&
      formData.operator_code &&
      (formData.amount > 0)
  ) {
      setFieldValid(false);
  }else{
    setFieldValid(true);
  }
  }
  
  const validateMobileNumber = (mobileNumber) => {
    const regex = /^[6-9]\d{9}$/;
    return regex.test(mobileNumber);
  };
  const navigate = useNavigate();
  const BillMyDTH = async () => { 
    const { operator_code, DTH, amount,payment_method } = formData;
    if (DTH === '') {
      setFieldValid(true);
         return;
       }
   
       if (!validateMobileNumber(DTH)) {
        setFieldValid(true);
         return;
       }
   
       if (operator_code === '') {

        setFieldValid(true);
         return;
       }
   
       if (amount === '' || parseInt(amount) <= 0) {

        setFieldValid(true);
         return;
       }
     navigate(
      '/cart/recharge',
      { replace: true,
        state: {
          op_code: operatorList[formData.operatorIndex].op_code,
          serial_no: formData.DTH,
          amount: formData.amount,
          circle:2,
          op_image: operatorList[formData.operatorIndex].operator_image,
          text1: `Mobile Number ${formData.DTH}`,
          text2: `Recharge ${operatorList[formData.operatorIndex].operator_name} with `,     pageno:props.pageNo,                redirect:"/bill-payments"
        },
      }
    );


    // const response = await MyBillsApi.RechargeMyDTHApi(
    //   formData.operator_code,
    //   formData.DTH,
    //   parseInt(formData.amount),
    //   formData.coupon_id,
    //   formData.payment_method
    // );
    // console.log(response);
    // if (response.data.error !== '') {
    //   notify('error', response.data.error);
    // } else {
    //   notify('success', 'DTH Recharge Done SuccessFully');
    // }
  };

  return (
    <React.Fragment>
      <div className='my-electricity-recharge-main-page-container'>
        <div className='my-electricity-recharge-main-page-container-heading'>
          <div>
            <img src={bulb}></img>
          </div>
          <div>
            Let's Get Your<br></br>
            <span>Electricity Bill Payment Done</span>
            <hr></hr>
          </div>
        </div>
        <div className='my-electricity-recharge-main-page-container-main-content'>
          <div className='my-electricity-recharge-main-page-container-main-content-col1'>
            <div className='my-dth-recharge-main-page-container-main-content-col1-inputs'>
            <div className={`my-dth-recharge-main-page-container-main-content-col1-inputs-1 ${(!formData.DTH&& fieldValid) || (formData.DTH && !validateMobileNumber(formData.DTH)) ? 'error' : ''}`}>

                <input
                  type='text'
                  value={formData.DTH}
                  onChange={ChangeValue}
                  name='DTH'
                  placeholder='Enter Customer Id'
                ></input>
                 {(!formData.DTH && fieldValid) && <span className="error-message">Please enter your Customer ID</span>}
                {formData.DTH && !validateMobileNumber(formData.DTH) && <span className="error-message"> Please enter a valid Customer ID</span>}
              </div>
              <div className={`my-dth-recharge-main-page-container-main-content-col1-inputs-1 ${(!formData.operator_code) && fieldValid ? 'error' : ''}`}>
   

                  <input
                    list='my-electricity-recharge-main-page-container-main-content-col1-list'
                    onChange={ChangeValue}
                    name='operator_code'
                    placeholder="Select Your Provider"
                  />
                     {(!formData.operator_code && fieldValid) && <span className="error-message">Please select an Operator</span>}

                  <datalist id='my-electricity-recharge-main-page-container-main-content-col1-list'>
                    <option value=''>Select Your Provider</option>
                    {operatorList &&
                      operatorList.length > 0 &&
                      operatorList.map((item) => {
                        return (
                          <option value={item.op_code}>
                            {item.operator_name}
                          </option>
                        );
                      })}
                  </datalist>
                
              </div>
              <div className={`my-dth-recharge-main-page-container-main-content-col1-inputs-1 ${(!formData.amount || !formData.amount.trim() || parseInt(formData.amount) <= 0) && fieldValid ? 'error' : ''}`}>

                <input
                  type='number'
                  value={formData.amount}
                  onChange={ChangeValue}
                  name='amount'
                  placeholder='Enter Recharge Amount'
                ></input>
                 {(!formData.amount  && fieldValid) && <span className="error-message">Please enter a recharge amount</span>}
                {(formData.amount &&formData.amount <= 0 && fieldValid) && <span className="error-message">Please enter a valid recharge amount</span>}
              </div>
              {/* <div className='my-dth-recharge-main-page-container-main-content-col1-inputs-2'>
                <span>Payment Method</span>
                <form>
                  <input
                    id='payment-mode-input-id-is-online-payment-my-dth-recharge'
                    type='radio'
                    name='payment_method'
                    value='paytm'
                    onChange={ChangeValue}
                  ></input>
                  <label htmlFor='payment-mode-input-id-is-online-payment-my-dth-recharge'>
                    Pay Now
                  </label>
                  <br></br>
                  {Userprofile ? (
                    <>
                      {Userprofile.wallet_balance === 1 ||
                      Userprofile.wallet_balance === 0 ? (
                        <></>
                      ) : (
                        // <span>Your current wallet balance is 0.00</span>
                        <>
                          <input
                            id='payment-mode-input-id-is-wallet-payment-my-dth-recharge'
                            type='radio'
                            name='payment_method'
                            value='wallet'
                            onChange={ChangeValue}
                          ></input>
                          <label htmlFor='payment-mode-input-id-is-wallet-payment-my-dth-recharge'>
                            Wallet
                          </label>
                          <br></br>
                        </>
                      )}
                    </>
                  ) : (
                    <span></span>
                  )}
                </form>
              </div> */}
              <div className='my-dth-recharge-main-page-container-main-content-col1-inputs-button'>
                <button onClick={BillMyDTH}>Proceed</button>
              </div>
            </div>
          </div>
          <div className='my-electricity-recharge-main-page-container-main-content-col2 bill-payments-col2-mobile-view'>
            <div>
              <img src={coverImage}></img>
            </div>
          </div>
        </div>

        <div className='my-dth-recharge-main-page-container-allProvider-content'>
          <div className='my-dth-recharge-main-page-container-allProvider-content-all-provider'>
            All Providers
          </div>
          <div className='my-dth-recharge-main-page-container-allProvider-content-all-provider-card-holder'>
            {operatorList &&
              operatorList.length > 0 &&
              operatorList.map((item) => {
                return (
                  <div className='my-dth-recharge-main-page-container-allProvider-content-all-provider-cards'>
                    <div className='my-dth-recharge-main-page-container-allProvider-content-all-provider-cards-col1'>
                      <div>
                        <img src={item.operator_image}></img>
                      </div>
                    </div>
                    <div className='my-dth-recharge-main-page-container-allProvider-content-all-provider-cards-col2'>
                      {item.operator_name}
                    </div>
                  </div>
                );
              })}
          </div>
        </div>

      
      </div>
    </React.Fragment>
  );
}
